import React from "react";

export default function FullWidthImage({ src, alt = "" }) {
  return (
    <section style={styles.wrapper}>
      <img
        src={src}
        alt={alt}
        style={styles.image}
      />

      {/* <div style={styles.copyright}>
        © 2025 Rushcut. All rights reserved.
      </div> */}
    </section>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ededed",
    alignItems: "center",
  },
  image: {
    width: "100.5%",     // ✅ full viewport width
    height: "auto",
    maxHeight: "100vh",
    objectFit: "cover",
    display: "block",
    marginBottom: '-1.4%',
  },
  // copyright: {
  //   marginTop:"12px",
  //   marginBottom: "12px",
  //   fontSize: "14px",
  //   color: "#666",
  //   textAlign: "center",
  // },
};
